import React from 'react';
import AppStoreButton from '../components/AppStoreButton';
import GooglePlayButton from '../components/GooglePlayButton';
import './Links.css';

const Links = () => {
  return (
    <div className="page-container links-page">
      <header className="links-header">
        <h1>Links</h1>
      </header>

      <section className="links-section">
        <div className="links-option">
          <p className="links-label">Web App</p>
          <a
            href="https://hanzi-flashcards.com"
            target="_blank"
            rel="noopener noreferrer"
            className="pwa-link"
          >
            hanzi-flashcards.com
          </a>
        </div>

        <div className="links-option">
          <p className="links-label">Mobile App</p>
          <div className="store-buttons">
            <AppStoreButton />
            <GooglePlayButton />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Links;
